export default {
  utmParams: null,
  logoPdf: null,
  haveLogo: false,
  logoPdfFileName: '',
  haveCompany: false,
  havePassword: false,
  cerFileName: '',
  keyFileName: '',
  haveCer: false,
  haveKey: false,
  tradeName: '',
  password: '',
  cer: null,
  key: null,
  name: '',
  logo: '',
  rfc: '',
  ciec: '',
  curp: '',
  regime: '601',
  zipCode: '',
  employerRegistration: '',
  id: null,
  loading: false,
  multiUser: '',
  smsAvailable: null,
  packages: '',
};
